module.exports = __webpack_public_path__ + "media/honey-icons/icon-filter-69ffc465.svg";